import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ApiService } from '../../../services/api.service';
import { MessageService } from 'primeng/api';
import { environment } from '../../../../environments/environment';
import { FileUpload } from 'primeng/fileupload';
import { HttpClient } from '@angular/common/http';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Subscription } from 'rxjs';

// 
@Component({
  selector: 'app-scheme',
  standalone: false,
  templateUrl: './scheme.component.html',
  styleUrls: ['./scheme.component.scss']
})
export class SchemeComponent implements OnInit, OnDestroy {
  @ViewChild('fileUpload') fileUpload!: FileUpload;

  url = environment.APIUrl;
  expandedSchemeId: number | null = null;
  expandedsubSchemeId: number | null = null;
  expandedStageIds: Set<number> = new Set();
  displayDialog: boolean = false;
  schemeForm: FormGroup;
  stapeForm: FormGroup;
  selectedScheme: any;
  file1: File | null = null;
  file2: File | null = null;
  currentSelectedSchemeID: any;
  schemes: any[] = [];
  stages: any[] = [];
  selectedId: any;
  showDeleteDialog: boolean = false;
  stepOptions: any;
  stapeId: any;
  schemeId: any
  deleteStepPopup: boolean = false
  files: File[] = []
  existingFiles: any[] = [];
  displayStapeDialog: boolean = false;
  selectedStape: any;
  selectedSchemeId: any
  selectedSchemeName: any
  isFileUploaded: boolean = false
  private subscriptions = new Subscription();
  sub_schemes: any;
 expandedSchemes: Set<number> = new Set();
expandedSubSchemes: Set<number> = new Set();
phase_sequence:any
  constructor(private api: ApiService, private messageService: MessageService, private http: HttpClient, private fb: FormBuilder,) {
    this.schemeForm = new FormGroup({
      name: new FormControl('', [
        Validators.required,
        Validators.pattern('^[a-zA-Z0-9 &]+$')
        // Only letters and spaces allowed
      ]),
      code: new FormControl('', [Validators.required , Validators.pattern('^[a-zA-Z0-9 &]+$')]),
      description: new FormControl('', Validators.required),
      phases: new FormControl([]),
      scheme:new FormControl([])
    })
    this.stapeForm = this.fb.group({
      name: [[]],
      phase:  [{ value: null, disabled: true }] ,
      phase_sequence:[]
    });

  }

  ngOnInit(): void {
    this.apiCall();
  }
  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
  getTheName(url: string): string | undefined {
    try {
      const decodedUrl = decodeURIComponent(url);
      const fileName = decodedUrl.split('/').pop();
      return fileName?.split('?')[0]; // Remove any query parameters
    } catch (error) {
      console.error('Error parsing file URL:', error);
      return undefined;
    }
  }

  apiCall() {
    const sub = this.api.getAPI('/master/scheme/').subscribe((res: any) => {
      this.schemes = res;
    });
    this.subscriptions.add(sub);
  }

  toggleScheme(schemeId: number, event: Event , isSubScheme: boolean = false): void {
    event.stopPropagation();
    if(isSubScheme){
      console.log("sub" , schemeId)
      this.expandedsubSchemeId =this.expandedsubSchemeId == schemeId ? null : schemeId;
       this.getSchemeStep(schemeId)
    if (this.expandedsubSchemeId != null) {
      console.log("phase")
      this.getSchemewisePhase(this.expandedsubSchemeId)
      // this.getSubSchemes(schemeId)
    }
    }else{
  this.expandedSchemeId = this.expandedSchemeId == schemeId ? null : schemeId;
    // this.getStep(schemeId);
    this.getSchemeStep(schemeId)
    if (this.expandedSchemeId != null) {
      this.getSchemewisePhase(this.expandedSchemeId)
      this.getSubSchemes(schemeId)
    }
    }
  
  }

  toggleStage(stageId: number, event: Event): void {
    event.stopPropagation();
    if (this.expandedStageIds.has(stageId)) {
      this.expandedStageIds.delete(stageId);
    } else {
      this.expandedStageIds.add(stageId);
    }
  }
  getStep(schemeId: number) {
    this.currentSelectedSchemeID = schemeId;
    this.stages = [];
    const sub = this.api.getAPI(`/master/scheme-step/`).subscribe((res: any) => {
      this.stages = res.data;
    });
    this.subscriptions.add(sub);
  }
  isSchemeExpanded(schemeId: number): boolean {
    return this.expandedSchemeId == schemeId;
  }


  isSubSchemeExpanded(schemeId: number): boolean{
     return this.expandedsubSchemeId === schemeId;
  }
    getSubSchemes(scheme_id:number) {
   let url = scheme_id ?  `/master/scheme/sub/details/?id=${scheme_id}`:`/master/scheme/sub/details/`
    const sub = this.api
      .getAPI(url)
      .subscribe((res: any) => {
        this.sub_schemes = res[0]?.sub_scheme
      });
    this.subscriptions.add(sub);
  }

  isStageExpanded(stageId: number): boolean {
    return this.expandedStageIds.has(stageId);
  }

  onAdd() {
    this.schemeForm.reset();
    this.fileUpload.clear();
    this.selectedScheme = null
    this.files = [];
    this.existingFiles = []
    this.getPhase()
    this.displayDialog = true;
  }
  parentScheme:any
  addSub:boolean = false;
  onAddSubscheme(scheme:any){
 this.schemeForm.reset();
    this.fileUpload?.clear();
    this.selectedScheme = null
    this.files = [];
    this.existingFiles = []
    this.getPhase()
    this.displayDialog = true;
    this.parentScheme = scheme;
    this.addSub = true;
    this.schemeForm.get('scheme').patchValue(this.parentScheme.id)
  }
  removeExistingFile(index: number) {
    this.existingFiles.splice(index, 1);
  }
  onSave() {
    const formData = new FormData();
    formData.append('name', this.schemeForm.value.name);
    const phases = this.schemeForm.value.phases; // e.g., [1, 2, 3]
    // formData.append('phase', JSON.stringify(phases));
    if(phases.length){
  phases.forEach(id => {
      formData.append('phase', id); // or 'phase' if backend doesn't require []
    });
    }
  
    formData.append('description', this.schemeForm.value.description);
    formData.append('code', this.schemeForm.value.code);

    formData.append('status', '1');
    if(this.addSub){
      formData.append('parent', this.schemeForm.value.scheme);
    }

    // 1. Combine newly added files with existing files (file metadata)
    const allFiles = [...this.files, ...this.existingFiles]; // Merged array of both

    // 2. Append merged array of files to formData
    allFiles.forEach(file => {
      // If the file is a File object (newly uploaded file)
      if (file instanceof File) {
        formData.append('uploaded_files', file);
      }
      // If the file is metadata (existing files)
      else if (file.url || file.path) {
        // Convert the file metadata to string (for the backend)
        formData.append('uploaded_files', JSON.stringify(file));
      }
    });

    this.displayDialog = false;
    this.file1 = null;
    this.file2 = null;
    if (this.selectedScheme) {
      const sub = this.api.putAPI(`/master/scheme/${this.selectedScheme.id}/`, formData).subscribe((res: any) => {
        this.expandedSchemeId = this.selectedScheme.id
        this.apiCall();
        this.getSchemewisePhase(this.expandedSchemeId)
        this.fileUpload.clear();

        this.schemeForm.reset();
        this.selectedScheme = null;
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: res.message || 'Scheme updated successfully',
          life: 3000
        });

      });
      this.subscriptions.add(sub);
    } else {
      const sub = this.api.postAPI('/master/scheme/', formData).subscribe((res: any) => {
         this.expandedSchemeId = res.id
        this.apiCall();
        this.getSchemewisePhase(this.expandedSchemeId)
        this.schemeForm.reset();
        this.selectedScheme = null;
        this.fileUpload.clear();
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: res.message || 'Scheme added successfully',
          life: 3000
        });
      });
      this.subscriptions.add(sub);
    }
  }

  onFileChange(event: any) {
    // for(let file of event.target.files){
    //   this.files.push(file)
    // }
    this.files = [...event.files];

    this.messageService.add({
      severity: 'success',
      summary: 'Success',
      detail: 'Files Attached successfully',
      life: 3000
    });
    this.isFileUploaded = true;
  }

  onEdit(scheme: any) {
    this.getPhase();
    this.displayDialog = true;
    this.selectedScheme = scheme
    this.schemeForm.patchValue({
      name: scheme.name,
      code: scheme.code,
      phases: scheme.phase,
      description: scheme.description,
    });
    this.files = []; // Reset new files
    this.existingFiles = scheme.files || [];
    this.isFileUploaded = true
  }
  onshowDeleteDialog(schemeId: number) {
    this.showDeleteDialog = true;
    this.selectedId = schemeId
  }
  onDelete() {
    this.api.deleteAPI(`/master/scheme/${this.selectedId}/`).subscribe((res: any) => {
      this.messageService.add({
        severity: 'success',
        summary: 'Success',
        detail: 'Scheme deleted successfully'
      });
      this.apiCall();
    });
    this.showDeleteDialog = false;
  }

onAddStape(scheme: any, schemeName: string, phase: any): void {
  this.selectedSchemeId = scheme.id;
  this.expandedsubSchemeId = scheme.id
  this.selectedSchemeName = schemeName;
  this.selectedStageIds = [];
  this.timelineStages = [];
  this.stapeForm.patchValue({ phase: phase.id, phase_sequence: phase.sequence });
  console.log(scheme,'------------------------------------------------------')
  // Load phases for dropdown
  this.getSchemewisePhase(scheme.id);

  // Step 1: Load stages (steps) from backend
  const sub = this.api.getAPI(`/master/scheme-step/`).subscribe((res: any) => {
    this.stages = res.data || [];

    // Step 2: Get steps already mapped to this phase
    const alreadyAddedSteps = this.getPhaseSteps(phase.id); // from stepOptions

    // Step 3: Extract selected step IDs
    const selectedIds = alreadyAddedSteps.map(s => Number(s.step?.id || s.id));
    this.selectedStageIds = selectedIds;

    // Step 4: Build timeline table from already added steps
    this.timelineStages = alreadyAddedSteps.map(s => ({
      id: Number(s.step?.id || s.id),
      name: s.step?.name || '',
      description: s.step?.description || '',
      sequence: s.sequence || 0,
      week_timeline: s.week_timeline || null,  // Add timeline from API response
      percentage: s.percentage || null          // Add percentage from API response

    }));
  this.totalPercentage = this.timelineStages
    .map(stage => Number(stage.percentage) || 0)
    .reduce((sum, current) => sum + current, 0);

  // Round to handle floating point precision
  this.totalPercentage = parseFloat(this.totalPercentage.toFixed(2));
    // Step 5: Prepare dropdown options
    const allStageIds = this.stages.map(s => Number(s.id));
    const filtered = this.stages.filter(stage => !selectedIds.includes(Number(stage.id)));
    const selected = this.stages.filter(stage => selectedIds.includes(Number(stage.id)));

    this.filteredStages = [...selected, ...filtered];

    // Step 6: Patch dropdown selected values
    this.stapeForm.patchValue({ name: selectedIds });
  });

  this.subscriptions.add(sub);

  // Step 7: Finally, open dialog
  this.displayStapeDialog = true;
}



  submittedTimeline: any[] = [];
  totalPercentage = 0;

validatePercentage() {
  if (!this.timelineStages || this.timelineStages.length === 0) {
    this.totalPercentage = 0;
    return;
  }

  // Check if any step has percentage defined
  const hasPercentages = this.timelineStages.some(stage => 
    stage.percentage !== null && stage.percentage !== undefined && stage.percentage > 0
  );
console.log(hasPercentages)
  if (!hasPercentages) {
    // Auto-allocate equal percentages
    const equalPercent = 100 / this.timelineStages.length;
    this.timelineStages.forEach(stage => {
      stage.percentage = parseFloat(equalPercent.toFixed(2));
    });
  }

  // Calculate total percentage
  this.totalPercentage = this.timelineStages
    .map(stage => Number(stage.percentage) || 0)
    .reduce((sum, current) => sum + current, 0);

  // Round to handle floating point precision
  this.totalPercentage = parseFloat(this.totalPercentage.toFixed(2));
}

onSaveStape() {
  // Auto-allocate percentages if none provided
  if (this.timelineStages.every(stage => 
    stage.percentage === null || stage.percentage === undefined || stage.percentage === 0
  )) {
    this.validatePercentage(); // This will auto-allocate
  }

  // Map the timelineStages into a sequence-assigned array
  this.submittedTimeline = this.timelineStages.map((item, index) => ({
    ...item,
    sequence: index + 1,
    week_timeline: item.week_timeline || null,  // Keep null if not provided
    percentage: item.percentage || null         // Keep null if not provided
  }));
  console.log('t',this.phase_sequence)

  // Construct the payload
  const payload = this.submittedTimeline.map(step => ({
    scheme_id: this.selectedSchemeId,
    phase: this.stapeForm.get('phase').value,
    step_id: step.id,
    sequence: step.sequence,
    week_timeline: step.week_timeline,  // Can be null
    percentage: step.percentage ,        // Can be null
    phase_sequence:Number(this.stapeForm.get('phase_sequence').value),
  }));

  // Submit to API
  this.api.postAPI('/master/scheme-step/mapping/', payload).subscribe((res: any) => {
    this.onStepSaveSuccess(res);
  });
}

  // Success handler
  onStepSaveSuccess(res: any) {
    this.displayStapeDialog = false;
    this.getSchemeStep(this.selectedSchemeId);
    this.stapeForm.reset();
    this.selectedSchemeId = null;

    this.messageService.add({
      severity: 'success',
      summary: 'Success',
      detail: res.message || 'Step added successfully',
      life: 3000
    });
  }


  onEditStage(stape: any) {
    this.displayStapeDialog = true;
    this.selectedStape = stape;
    this.validatePercentage()
    this.stapeForm.patchValue({
      name: stape.name,
      // description: stape.description,
      sequence: stape.sequence,
      // code: stape.code,

    });
  }

  // selectedSchemeId:any
  onDeleteStage(stapeId: any, schemeId: any) {
    this.schemeId = schemeId;
    this.stapeId = stapeId.id
    this.deleteStepPopup = true

  }
  confirmDeleteStage() {
    const sub = this.api.deleteAPI(`/master/scheme-step/mapping/${this.stapeId}/`).subscribe((res: any) => {
      this.deleteStepPopup = false
      this.messageService.add({
        severity: 'success',
        summary: 'Success',
        detail: ' Stage deleted successfully'
      });
      this.getSchemeStep(this.schemeId)
    });
    this.subscriptions.add(sub);
  }
  isFilepopup = false;
  fileList(event) {
    this.isFilepopup = true
    this.selectedScheme = event;
  }
  download(link) {
    if (!link) return;

    // Extract filename from the link if not provided
    const extractedFilename = link.split('/').pop() || 'file';

    const url = `${environment.APIUrl}${link}`;

    this.http.get(url, { responseType: 'blob' }).subscribe(blob => {
      const blobUrl = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = blobUrl;
      a.download = extractedFilename;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(blobUrl);
    });
  }
  getSchemeStep(schemeId: any) {

    const sub = this.api.getAPI(`/master/scheme-step/mapping/?scheme=${schemeId}`).subscribe((res: any) => {
      this.stepOptions = res;
      // Normalize: extract step info + set correct sequence
      this.timelineStages = res.map((item: any, index: number) => ({
        id: item.step.id,
        name: item.step.name,
        description: item.step.description,
        sequence: index + 1,
        week_timeline: item.week_timeline || null,  // Add timeline from API response
      percentage: item.percentage || null          // Add percentage from API response
      }));
  // Calculate total percentage for validation
    this.validatePercentage();

      // Optional: patch to multi-select if needed
      this.selectedStageIds = this.timelineStages.map(stage => stage.id);


      // Pre-fill dropdown selection (if editing)
      this.selectedStageIds = this.timelineStages.map(stage => stage.id);
      this.stapeForm.patchValue({
        name: this.selectedStageIds,
      });


    });
    this.subscriptions.add(sub);
  }

  selectedStageIds: number[] = [];
  timelineStages: any[] = [];
  addtoTimelineClicked: boolean = false


addToTimeline() {
  const selectedIds = this.stapeForm.get('name')?.value || [];
  const existingIds = this.timelineStages.map(s => s.id);

  // Use only filteredStages (steps belonging to selected phase)
  const newSteps = this.filteredStages.filter(
    s => selectedIds.includes(s.id) && !existingIds.includes(s.id)
  );

  // Append new steps and update sequence
  this.timelineStages = [...this.timelineStages, ...newSteps].map((step, index) => ({
    ...step,
    sequence: index + 1
  }));

  // Optional: clear selection after adding
  // this.stapeForm.patchValue({ name: [] });
  // this.selectedStageIds = [];

  this.addtoTimelineClicked = true;
}


  drop(event: any) {
    moveItemInArray(this.timelineStages, event.previousIndex, event.currentIndex);
  }
  removeFromTimeline(stepId: number) {
    // Remove from timeline
    this.timelineStages = this.timelineStages.filter(stage => stage.id !== stepId);

    // Remove from selectedStageIds (which controls dropdown selection)
    this.selectedStageIds = this.selectedStageIds.filter(id => id !== stepId);

    // Update the form control to reflect the change
    this.stapeForm.patchValue({ name: this.selectedStageIds });
  }
  // onDropdownChange(selectedIds: number[]) {
  //   this.selectedStageIds = selectedIds;

  //   // Update timelineStages to include only those that are still selected
  //   this.timelineStages = this.timelineStages.filter(stage =>
  //     selectedIds.includes(stage.id)
  //   );

  //   // Optionally update the form control
  //   this.stapeForm.patchValue({ name: selectedIds });
  // }
  onStagesChanged(event: any) {
    this.selectedStageIds = event.value; // keep this updated if needed elsewhere
  }
  schemePhase: any
  getPhase() {
    const sub = this.api.getAPI('/master/phase/').subscribe((res) => {
      this.schemePhase = res.data || res.results
    });
    this.subscriptions.add(sub);
  }
  mapped_phases: any
  getSchemewisePhase(scheme_id?:number) {
     let url = '';

  if (scheme_id === this.expandedSchemeId) {
    // If scheme_id matches main scheme
    url = `/master/scheme/${this.expandedSchemeId}/phases/`;
  } else if (scheme_id === this.expandedsubSchemeId) {
    // If scheme_id matches sub-scheme
    url = `/master/scheme/${this.expandedsubSchemeId}/phases/`;
  } else {
    console.warn('Scheme ID does not match expanded main or sub scheme');
    return; 
  }

  console.log('API URL:', url);
    
    const sub = this.api.getAPI(url).subscribe((res) => {
      this.mapped_phases = res.sort((a: any, b: any) => a.sequence - b.sequence);
    });
    this.subscriptions.add(sub);
  }
 getPhaseSteps(phaseId: number): any[] {
  const phaseSteps = this.stepOptions?.filter(step => step.phase === phaseId);
  return phaseSteps;
}

  expandedPhases: { [schemeId: number]: number | null } = {};
  togglePhase(schemeId: number, phaseId: number): void {

    if (this.expandedPhases[schemeId] === phaseId) {
      this.expandedPhases[schemeId] = null;
    } else {
      this.expandedPhases[schemeId] = phaseId;
    }
  }
  isPhaseExpanded(schemeId: number, phaseId: number): boolean {
    return this.expandedPhases[schemeId] == phaseId;
  }
selectedPhaseId: number;
filteredStages: any[] = [];

onPhaseChanged(phaseId: number): void {
  this.filterAvailableStages(phaseId);
  this.selectedStageIds = [];
  this.timelineStages = [];
}


filterAvailableStages(phaseId: number): void {
  const alreadyAddedStepIds = this.getPhaseSteps(phaseId).map(s => s.step?.id || s.id);

  // Step options excluding already added ones
  this.filteredStages = this.stages.filter(stage =>
    !alreadyAddedStepIds.includes(stage.id)
  );

  // ✅ Clear any invalid selectedStageIds (not in filtered options)
  const validIds = this.filteredStages.map(s => s.id);
  const selectedIds = this.stapeForm.get('name')?.value || [];

  const cleanedSelection = selectedIds.filter((id: number) => validIds.includes(id));

  this.stapeForm.patchValue({ name: cleanedSelection });
  this.selectedStageIds = cleanedSelection;
}
  allowOnlyNumbers(event: KeyboardEvent) {
    const allowedKeys = ['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight'];
    if (allowedKeys.includes(event.key)) return;

    const isNumber = /^[0-9]$/.test(event.key);
    if (!isNumber) {
      event.preventDefault();
    }
  }
}